import React from 'react'
import { Heading, Flex, Box } from 'rebass/styled-components'
import styled, { keyframes } from 'styled-components'
import PropTypes from 'prop-types'
import ChevronDownSvg from '../public/static/icon/chevron-down.svg'
import Link from 'next/link'

const BannerHeading = styled(Heading)`
  font-weight: ${(props) => props.theme.fontWeights[1]};
  color: ${(props) => props.theme.colors.white};
  text-transform: uppercase;
  text-shadow: 0 0 1px ${(props) => props.theme.colors.gray2};
  letter-spacing: ${(props) => props.theme.letterSpacing};
`

const Wrapper = styled(Flex)`
  cursor: pointer;
  transition: padding 250ms ease;
  &:hover {
    padding: 1.4em 0;
  }
`

const pulse = keyframes`
  0% {
    transform: rotate(-90deg) scale(0.3);
  }

  100% {
    transform: rotate(-90deg) scale(0.4);
    opacity: 0.5;
  }
`

const Chevron = styled(ChevronDownSvg)`
  animation: ${pulse} 700ms ease-in-out alternate infinite;
  & path {
    stroke: ${(props) => props.theme.colors.white};
  }
`

const NoStyleLink = styled(Link)`
text-decoration: none;
    color: unset;
`

const CallToAction = ({
  onClick,
  url = '/contact',
  text = `Ready, Set, Let's Go`,
}) => (
    <Wrapper
      center={1}
      alignItems='center'
      justifyContent='center'
      py={3}
      onClick={onClick}
    >
      <Box>
        <BannerHeading
            sx={{
                textAlign: 'center',
                fontSize: [3, 3, 5, 6]
            }}>
  <NoStyleLink href={url}>
          {text}
  </NoStyleLink>
        </BannerHeading>
      </Box>
      <Box width={'0%'}>
        <Chevron />
      </Box>
    </Wrapper>
)

CallToAction.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  url: PropTypes.string,
}

export default CallToAction
